<!-- Floating Action Button -->
<button (click)="openFeedbackModal()"
        type="button"
        class="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 text-white bg-gradient-to-br from-primary-600 to-primary-700 hover:from-primary-700 hover:to-primary-800 rounded-full shadow-lg hover:shadow-xl focus:ring-4 focus:ring-primary-300 focus:outline-none dark:focus:ring-primary-800 transition-all duration-200 transform hover:scale-110 group"
        title="{{ 'Ask for Feedback' | translate }}">
  <!-- Icon: Message/Chat Bubble with Star -->
  <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path>
  </svg>
  
  <!-- Tooltip on Hover -->
  <span class="absolute right-16 px-3 py-2 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
    {{ 'Ask for Anonymous Feedback' | translate }}
  </span>

  <!-- Pulsing indicator (optional - shows it's new/available) -->
  <span class="absolute top-0 right-0 flex h-3 w-3">
    <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-400 opacity-75"></span>
    <span class="relative inline-flex rounded-full h-3 w-3 bg-yellow-500"></span>
  </span>
</button>





